import { render, staticRenderFns } from "./atendimentos_filial.vue?vue&type=template&id=1153f17f"
import script from "./atendimentos_filial.vue?vue&type=script&lang=js"
export * from "./atendimentos_filial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports